import { __decorate } from "tslib";
import { Component, Vue, Prop, Provide } from "../../vue";
import DsLogList from "../WConsole/child/DsLogList";
import styles from "./style.module.css";
import get from "lodash-es/get";
let LogPanelForDevTool = class LogPanelForDevTool extends Vue {
  constructor() {
    super(...arguments);
    this.devToolDoc = get(this.uc, 'root.devTool.windowRef.document');
  }
  render() {
    var _window$xy_runtime_pr;
    const h = arguments[0];
    return h("div", {
      "class": styles.logPanel
    }, [h(DsLogList, {
      "attrs": {
        "projectId": (_window$xy_runtime_pr = window.xy_runtime_project) === null || _window$xy_runtime_pr === void 0 ? void 0 : _window$xy_runtime_pr.id
      }
    })]);
  }
};
__decorate([Prop()], LogPanelForDevTool.prototype, "uc", void 0);
__decorate([Provide('devToolDoc')], LogPanelForDevTool.prototype, "devToolDoc", void 0);
LogPanelForDevTool = __decorate([Component({
  name: 'LogPanelForDevTool'
})], LogPanelForDevTool);
export default LogPanelForDevTool;
//# sourceMappingURL=LogPanel.js.map
